import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectUserSettingsState = (state: RootState) => state.authState;

export const selectUserSettingsObject = createSelector(
  selectUserSettingsState,
  (state) => state.settingsObject,
);

export const selectUserSettingsObjects = createSelector(
  selectUserSettingsState,
  (state) => state.settingsObjects,
);

export const selectUserInfo = createSelector(
  selectUserSettingsState,
  (state) => state.userInfo,
);

export const selectUserArtifactGroup = createSelector(selectUserInfo, (info) =>
  info?.["user-groups"].includes("/artifacts") ? "artifacts" : null,
);

export const selectValidationData = createSelector(
  selectUserSettingsState,
  (state) => state.validation,
);

export const selectUserSettings = createSelector(
  selectUserSettingsState,
  (state) => {
    if (state.userSettings?.user_settings) return [];

    return state.userSettings?.user_settings;
  },
);

export const selectUserSettingsLinks = createSelector(
  selectUserSettingsState,
  (state) => {
    if (state.userSettings?.user_settings) return [];

    return state.userSettings?.user_settings?.app_links;
  },
);

export const selectIsAuthenticated = createSelector(
  selectUserSettingsState,
  (state) => state.isAuthenticated,
);

export const selectIsUserInfoLoading = createSelector(
  selectUserSettingsState,
  (state) => state.isLoading,
);
